import PaymentModal from './PaymentModal'

export default PaymentModal
